import styled from "styled-components";

export const PageRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
`;

export const PageContainer = styled.div`
  width: 1100px;
  min-width: 1100px;
  margin: auto;
`;


export const PageTitle = styled.div`
  /* border: 1px solid black; */
  font-size: 20px;
  font-weight: bold;
  text-align: start;
  margin-top: 40px;
`;

export const GridContainer = styled.div`
  display: grid;
  
  grid-template-areas:
    "Payment OrderHistory"
    "MonsterPoint OrderHistory"
    "MonsterPoint OrderHistory";
  /* border: 1px solid black; */
  column-gap: 30px;
`;

// export const HeaderConatiner = styled.div`
//   display: flex;
//   padding-top: 10px;
//   padding-bottom: 10px;

//   border: 1px solid black;
//   border-bottom: 2px solid green;
// `;

// export const HeaderIcon = styled.img`
//   margin-right: 10px;
//   border: 1px solid black;
// `;
// export const HeaderText = styled.div`
//   border: 1px solid black;
// `;
